// import { findShortestPath } from '@/utilities/findShortestPath';
import Activity from '@/models/Activity';

export default class DrinkCoffee extends Activity {
  constructor({
    reference, departurePath, returnPath, originalActivity, pantry,
  }) {
    super({ reference });

    this.reference.skills.moving.setPath(departurePath);
    this.onReturnPath = false;
    this.returnPath = returnPath;
    this.originalActivity = originalActivity;
    this.pantry = pantry;
  }

  // eslint-disable-next-line class-methods-use-this
  execute() {
    if (this.onReturnPath) {
      this.finish();
      return;
    }
    this.reference.fatigueValue = 0;
    this.pantry.leave(this.reference);
    this.reference.skills.moving.setPath(this.returnPath);
    this.onReturnPath = true;
  }

  // eslint-disable-next-line class-methods-use-this
  finish() {
    this.reference.setOnSeat();
    this.reference.setActivity(this.originalActivity);
  }
}
